import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
    Box,
    Button,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useGetContract } from "../../hooks/data/data_contract";
import { useGetAllocations } from "../../hooks/data/data_allocation";
import { IContract } from "../../interfaces/IContract";
import { IContractState } from "../../interfaces/IContractState";
import { IContractType } from "../../interfaces/IContractType";
import { ICustomer } from "../../interfaces/ICustomer";
import { IOffer } from "../../interfaces/IOffer";
import { IOfferState } from "../../interfaces/IOfferState";
import { IOfferType } from "../../interfaces/IOfferType";
import { IPartner } from "../../interfaces/IPartner";
import { IProject } from "../../interfaces/IProject";
import { IService } from "../../interfaces/IService";
import { IServiceCategory } from "../../interfaces/IServiceCategory";
import { ITemplate } from "../../interfaces/ITemplate";
import { IUnit } from "../../interfaces/IUnit";
import { CustomCircularProgress } from "../core/CustomCircularProgress";
import { ErrorTryRefetch } from "../core/ErrorTryRefetch";
import { AddContracts } from "./Childs/AddContracts";
import { ContractRow } from "./Childs/ContractRow";
import CraftsAllocationDialog from "./Childs/CraftsAllocationDialog";
import { IProjectPartnerAllocation } from "../../interfaces/IProjectPartnerAllocation";
interface IProps {
    project: IProject;
    contractStateArray: IContractState[];
    contractTypeArray: IContractType[];
    //
    offerArray: IOffer[] | undefined;
    offerStateArray: IOfferState[];
    offerTypeArray: IOfferType[];
    customerArray: ICustomer[];
    partnerArray: IPartner[];
    //
    templateArray: ITemplate[];
    serviceCategoryArray: IServiceCategory[];
    serviceArray: IService[];
    unitArray: IUnit[];
}

export const ContractTab: React.FC<IProps> = ({
    project,
    contractStateArray,
    contractTypeArray,
    offerArray,
    offerStateArray,
    offerTypeArray,
    customerArray,
    partnerArray,
    templateArray,
    serviceCategoryArray,
    serviceArray,
    unitArray,
}) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [isMountAllocationDialog, setIsMountAllocationDialog] = useState(false);

    const { contractArray, isLoadingContractArray, refetchContractArray } = useGetContract(project.id);
    const { allocationArray, isLoadingAllocationArray, refetchAllocationArray } = useGetAllocations(project.id);
    const [contracts, setContracts] = useState<IContract[]>(contractArray || []);
    const [allocations, setAllocations] = useState<IProjectPartnerAllocation[]>(allocationArray || []);
    const [contractType, setContractType] = useState<IContractType>();
    const [isOpenNew, setIsOpenNew] = useState(false);
    const [createAllocationContract, setCreateAllocationContract] = useState(true);

    const isAllocationPresent = useMemo(() => {
        return allocationArray && allocationArray.length > 0;
    }, [allocationArray]);

    useEffect(() => {
        if (contractArray !== undefined) {
            setContracts(contractArray);
        }
    }, [contractArray]);

    useEffect(() => {
        if (allocationArray !== undefined) {
            setAllocations(allocationArray);
        }
    }, [allocationArray]);

    if (isLoadingContractArray || offerArray === undefined) {
        return <CustomCircularProgress />;
    }

    if (!contractArray) {
        return <ErrorTryRefetch refetchFunction={refetchContractArray} />;
    }

    if (isLoadingAllocationArray) {
        return <CustomCircularProgress />;
    }

    if (!allocationArray) {
        return <ErrorTryRefetch refetchFunction={refetchAllocationArray} />;
    }

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography variant="h5">Verträge</Typography>
                <Box>
                    {isAllocationPresent && (
                        <Button
                            onClick={() => {
                                setCreateAllocationContract(false);
                                setIsMountAllocationDialog(true);
                            }}
                            variant="outlined"
                            sx={{ mr: 2 }}
                        >
                            Zuweisung von Handwerkerbeauftragungen
                        </Button>
                    )}

                    <Button
                        variant="contained"
                        endIcon={<KeyboardArrowDownIcon />}
                        onClick={(event) => setAnchorEl(event.currentTarget)}
                    >
                        Neuer Vertrag
                    </Button>
                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                        {contractTypeArray.map((ct, i) => {
                            if (ct.id === 30) {
                                return (
                                    <MenuItem
                                        onClick={() => {
                                            setIsMountAllocationDialog(true);
                                            setAnchorEl(null);
                                        }}
                                    >
                                        Handwerkerbeauftragungen
                                    </MenuItem>
                                );
                            } else
                                return (
                                    <MenuItem
                                        key={i}
                                        onClick={() => {
                                            setIsOpenNew(true);
                                            setContractType(ct);
                                            setAnchorEl(null);
                                        }}
                                    >
                                        {ct.contractType}
                                    </MenuItem>
                                );
                        })}
                    </Menu>
                </Box>
            </Box>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width: 100 }}>Nr.</TableCell>
                        <TableCell sx={{ width: 200 }}>Art</TableCell>
                        <TableCell sx={{ width: 200 }}>Status</TableCell>
                        <TableCell>Titel</TableCell>
                        <TableCell sx={{ width: 160 }}>Aktionen</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {contracts.map((contract) => (
                        <ContractRow
                            key={`edit-contract-${contract.id}`}
                            project={project}
                            contractObject={contract}
                            setContractArray={setContracts}
                            contractStateArray={contractStateArray}
                            contractTypeArray={contractTypeArray}
                            templateArray={templateArray}
                            refetchContractArray={refetchContractArray}
                            serviceCategoryArray={serviceCategoryArray}
                            serviceArray={serviceArray}
                            unitArray={unitArray}
                        />
                    ))}
                </TableBody>
            </Table>

            {isOpenNew && (
                <AddContracts
                    project={project}
                    contractStateArray={contractStateArray}
                    contractType={contractType!}
                    offerArray={offerArray || []}
                    customerArray={customerArray}
                    partnerArray={partnerArray}
                    handleClose={() => setIsOpenNew(false)}
                    handleSave={() => {
                        refetchContractArray();
                        setIsOpenNew(false);
                    }}
                />
            )}

            {isMountAllocationDialog && (
                <CraftsAllocationDialog
                    createContract={createAllocationContract}
                    project={project}
                    offers={offerArray}
                    offerStates={offerStateArray}
                    offerTypes={offerTypeArray}
                    allPartners={partnerArray}
                    units={unitArray}
                    refetchContracts={refetchContractArray}
                    refetchAllocations={refetchAllocationArray}
                    allocations={allocations}
                    unmount={() => {
                        setIsMountAllocationDialog(false);
                        setCreateAllocationContract(true);
                    }}
                />
            )}
        </>
    );
};
